import { FINITE_ORDER_STATUSES, Order, OrderStatus } from 'src/models/Order'
import { ViewMode } from 'src/utils/env'

export enum EmptyTranscriptTemplate {
    sessionScheduled = 'sessionScheduled',
    waitingForTranscript = 'waitingForTranscript',
    waitingForDocument = 'waitingForDocument',
    settingUpSession = 'settingUpSession',
    readyToConnect = 'readyToConnect',
    sessionEnded = 'sessionEnded',
}

export type GetTemplateTypeParams = {
    viewMode: ViewMode | null
    order: Order | null
    isOrderLoading: boolean
    isMediaRecorderAvailable: boolean
    currentTime: Date
}

export const getTemplateType = (params: GetTemplateTypeParams): EmptyTranscriptTemplate | null => {
    const { viewMode, order, isOrderLoading, isMediaRecorderAvailable, currentTime } = params

    if (viewMode === 'document') {
        return EmptyTranscriptTemplate.waitingForDocument
    }

    if (order === null) {
        return isOrderLoading ? null : EmptyTranscriptTemplate.waitingForTranscript
    }

    if (FINITE_ORDER_STATUSES.has(order.status.name)) {
        return EmptyTranscriptTemplate.sessionEnded
    }

    const scheduledStartTime = order.input.schedule?.start_at
    if (scheduledStartTime && currentTime < new Date(scheduledStartTime)) {
        return EmptyTranscriptTemplate.sessionScheduled
    }

    if (!isMediaRecorderAvailable) {
        return EmptyTranscriptTemplate.waitingForTranscript
    }

    if (order.status.name === OrderStatus.ReadyToConnect || order.status.name === OrderStatus.InProgress) {
        return EmptyTranscriptTemplate.readyToConnect
    }

    return EmptyTranscriptTemplate.settingUpSession
}
